/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedChevronsUp = createReactComponent(
  "square-rounded-chevrons-up",
  "IconSquareRoundedChevronsUp",
  [
    ["path", { d: "M9 15l3 -3l3 3", key: "svg-0" }],
    ["path", { d: "M9 11l3 -3l3 3", key: "svg-1" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-2"
      }
    ]
  ]
);

export { IconSquareRoundedChevronsUp as default };
//# sourceMappingURL=IconSquareRoundedChevronsUp.js.map
